import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/hooks/useAuth";

/**
 * Allows access only to authenticated users whose role === 'admin'.
 * - Still initializing → render nothing (avoid flash redirect).
 * - Not authenticated   → redirect to /auth/login.
 * - Authenticated but not admin → redirect to /dashboard.
 */
const ProtectedAdminRoute = ({ children }) => {
  const { state } = useAuth();
  const location  = useLocation();

  if (state.isInitializing) return null;

  if (!state.isAuthenticated || !state.token) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  if (state.user?.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
